var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { average, calculateNextSnr, compareTriplets, createDinTestSteps, defaultCutOffs, getCategory, getNormalizedScoreDichotic, toTriplet, } from './utils';
import sendTestData from '../../../hx-analytics/src/functions/sendTestData';
import { logGroup } from 'hx-util';
import { getEventTracker } from 'hx-analytics';
/**
 * @deprecated Use DIN_TEST_FEATURE_KEY returned by {@link createDinTestStore}
 */
export var DIN_TEST_FEATURE_KEY = 'dinTest';
export var defaultInitialDinTestState = {
    initialized: false,
    status: 'idle',
    completion: 'not-started',
    steps: [],
    result: {
        averageSnr: undefined,
        score: undefined,
        category: undefined,
        timestamp: undefined,
        pass: undefined,
    },
};
export var createDinTestStore = function (initialDinTestState, _a, featureKey) {
    if (initialDinTestState === void 0) { initialDinTestState = defaultInitialDinTestState; }
    var _b = _a === void 0 ? {} : _a, _c = _b.startSnr, startSnr = _c === void 0 ? 0 : _c, _d = _b.bigStep, bigStep = _d === void 0 ? 4 : _d, _e = _b.smallStep, smallStep = _e === void 0 ? 2 : _e, _f = _b.steps, steps = _f === void 0 ? 23 : _f, _g = _b.maxSnr, maxSnr = _g === void 0 ? 8 : _g, _h = _b.minSnr, minSnr = _h === void 0 ? -22 : _h, _j = _b.cutOffs, cutOffs = _j === void 0 ? defaultCutOffs : _j, _k = _b.passFailCutOff, passFailCutOff = _k === void 0 ? cutOffs[0].snr : _k, _l = _b.normalizeFn, normalizeFn = _l === void 0 ? getNormalizedScoreDichotic : _l;
    if (featureKey === void 0) { featureKey = 'dinTest'; }
    var sendData = createAsyncThunk("".concat(featureKey, "/sendData"), function (payload, _a) {
        var getState = _a.getState, rejectWithValue = _a.rejectWithValue;
        return __awaiter(void 0, void 0, void 0, function () {
            var state, _b, result, steps, ear, completion, sessionId, trackCustom, error_1;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        state = getState();
                        _b = state[featureKey], result = _b.result, steps = _b.steps, ear = _b.ear, completion = _b.completion;
                        sessionId = state.widget.sessionId;
                        trackCustom = getEventTracker().trackCustom;
                        trackCustom('test_results', {
                            result: result,
                            steps: steps,
                            completion: completion,
                        });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, sendTestData({
                                source: ((_c = state.widget.hostDetails) === null || _c === void 0 ? void 0 : _c.source) || {
                                    origin: window.location.origin,
                                    hostname: window.location.hostname,
                                },
                                sessionId: sessionId,
                                result: result,
                                steps: steps,
                                ear: ear,
                                completion: completion,
                                name: payload === null || payload === void 0 ? void 0 : payload.testName,
                            })];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        console.error(error_1);
                        // if (process.env.REACT_APP_SENTRY_DSN) {
                        //   Sentry.captureException(error);
                        // }
                        return [2 /*return*/, rejectWithValue(error_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    });
    var dinTestSlice = createSlice({
        name: featureKey,
        initialState: initialDinTestState,
        reducers: {
            endSession: function (state) {
                state.initialized = false;
                state.steps = [];
                state.result = {
                    averageSnr: undefined,
                    score: undefined,
                    category: undefined,
                    timestamp: undefined,
                    pass: undefined,
                };
            },
            initializeTest: function (state) {
                if (state.initialized)
                    return;
                state.steps = createDinTestSteps(steps);
                state.initialized = true;
                state.completion = 'in-progress';
            },
            reset: function () { return initialDinTestState; },
            setSnr: function (state, action) {
                var nextSnr;
                var activeStepIndex = action.payload - 1;
                if (activeStepIndex === 0) {
                    nextSnr = startSnr;
                }
                else {
                    var previousSnr = state.steps[activeStepIndex - 1].snr || startSnr;
                    var didPassPrevious = state.steps[activeStepIndex - 1].passed;
                    var stepSize = activeStepIndex <= 3 ? bigStep : smallStep;
                    nextSnr = calculateNextSnr(previousSnr, didPassPrevious, {
                        stepSize: stepSize,
                        maxSnr: maxSnr,
                        minSnr: minSnr,
                    });
                }
                state.steps[activeStepIndex].snr = nextSnr;
            },
            submitResponse: function (state, action) {
                var _a = action.payload, response = _a.response, id = _a.id;
                var index = id - 1;
                var challenge = state.steps[index].challenge;
                var passed = compareTriplets(challenge, toTriplet(response));
                var timestamp = Date.now() / 1000;
                state.steps[index].response = toTriplet(response);
                state.steps[index].passed = passed;
                state.steps[index].timestamp = timestamp;
            },
            processResult: function (state) {
                var previousStep = state.steps[state.steps.length - 1];
                if (!previousStep.snr && previousStep.snr !== 0)
                    throw new Error('Invalid state: snr is undefined');
                var snrs = __spreadArray(__spreadArray([], state.steps.slice(4).map(function (step) { return step.snr; }), true), [
                    calculateNextSnr(previousStep.snr, previousStep.passed, {
                        stepSize: smallStep,
                        maxSnr: maxSnr,
                        minSnr: minSnr,
                    }),
                ], false);
                var averageSnr = average(snrs);
                var score = normalizeFn(averageSnr);
                var category = getCategory(averageSnr, cutOffs);
                var timestamp = Date.now() / 1000;
                var pass = averageSnr < passFailCutOff;
                var result = { averageSnr: averageSnr, score: score, category: category, timestamp: timestamp, pass: pass };
                logGroup('Final test result', {
                    'Average SNR': averageSnr,
                    Score: score,
                    Category: category,
                });
                state.completion = 'complete';
                state.result = result;
            },
            setTestId: function (state, action) {
                state.testId = action.payload;
            },
            update: function (state, action) {
                return Object.assign(state, action.payload);
            },
            discontinue: function (state) {
                state.initialized = false;
                state.completion = 'discontinued';
                state.result = {
                    averageSnr: undefined,
                    score: undefined,
                    category: undefined,
                    timestamp: undefined,
                    pass: undefined,
                };
            },
        },
        extraReducers: function (builder) {
            builder
                .addCase(sendData.pending, function (state) {
                if (state.status === 'idle') {
                    state.status = 'pending';
                }
            })
                .addCase(sendData.fulfilled, function (state) {
                if (state.status === 'pending') {
                    state.status = 'idle';
                    state.error = undefined;
                }
            })
                .addCase(sendData.rejected, function (state, action) {
                if (state.status === 'pending') {
                    state.status = 'idle';
                    state.error = action.error;
                }
            });
        },
    });
    var dinTestStoreReducer = dinTestSlice.reducer;
    var dinTestActions = __assign(__assign({}, dinTestSlice.actions), { sendData: sendData });
    var selectDinTest = function (state) { return state[featureKey]; };
    var useDinTestSelector = useSelector;
    var selectActiveTestStep = function (id) {
        return createSelector(selectDinTest, function (state) {
            return (state.steps.length && state.steps[id]) || {};
        });
    };
    var selectResultCategory = function (state) {
        return state.result.category || '';
    };
    var selectTestInitialized = function (state) { return state.initialized; };
    var selectCompletion = function (state) { return state.completion; };
    return {
        DIN_TEST_FEATURE_KEY: featureKey,
        dinTestSlice: dinTestSlice,
        dinTestStoreReducer: dinTestStoreReducer,
        dinTestActions: dinTestActions,
        useDinTestSelector: useDinTestSelector,
        selectActiveTestStep: selectActiveTestStep,
        selectResultCategory: selectResultCategory,
        selectCompletion: selectCompletion,
        selectTestInitialized: selectTestInitialized,
    };
};
/**
 * @deprecated Use selectors returned by {@link createDinTestStore}
 */
export var selectDinTest = function (state) { return state.dinTest; };
/**
 * @deprecated Use selectors returned by {@link createDinTestStore}
 */
export var useDinTestSelector = useSelector;
/**
 * @deprecated Use selectors returned by {@link createDinTestStore}
 */
export var selectActiveTestStep = function (id) {
    return createSelector(selectDinTest, function (state) {
        return (state.steps.length && state.steps[id]) || {};
    });
};
/**
 * @deprecated Use selectors returned by {@link createDinTestStore}
 */
export var selectResultCategory = function (state) {
    return state.result.category || '';
};
